import { initGrid } from 'utils/grid/grid';
import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';

import { isChainHeadSelector, isStoreProfileSelector } from 'selectors';
import { fetchSiteOperationalStatus } from 'dashboard/actions/site-operational-status/site-operational-status.actions';

import template from './site-operational-status-widget.html';

const mapStateToThis = ({ session, siteOperationalStatus, config }) => {
  const isChainHead = isChainHeadSelector({ session });
  const isStoreProfile = isStoreProfileSelector({ session });
  const { isEmpty, isLoading } = siteOperationalStatus;
  const { retailer } = session;
  const { sortColumnKey, directionKey, pageSizeKey, defaultPageSizes } = config;

  return {
    isChainHead,
    isStoreProfile,
    isEmpty,
    isLoading,
    retailer,
    sortColumnKey,
    directionKey,
    pageSizeKey,
    defaultPageSizes,
  };
};

const mapDispatchToThis = {
  fetchSiteOperationalStatus,
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state', 'gettextCatalog')
class SiteOperationalStatusWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.retailerId = parseInt(this.$state.params.retailerNo, 10) || this.retailer.retailerId;
    this.showRetailerList = this.isChainHead && !this.isStoreProfile;
    if (!this.isChainHead || this.isStoreProfile) {
      this.selectedRetailerId = this.retailerId;
    }
    this.$scope.$applyAsync(this.initTable());
  }

  $onDestroy() {
    this.unsubscribe();
  }

  async initTable() {
    this.headers = this.getHeaders();
    this.defaultParams = {
      [this.sortColumnKey]: 'status',
      [this.directionKey]: true,
      [this.pageSizeKey]: this.defaultPageSizes[1],
    };
    this.gridModel = await initGrid(this.fetchSiteOperationalStatus, this.defaultParams);
    this.initializeFilters();
    this.search();
  }

  initializeFilters() {
    this.gridModel.pagingModel.filters = {
      ...this.gridModel.pagingModel.filters,
      retailerId: this.retailerId,
    };
  }

  getHeaders() {
    return [
      {
        text: this.gettextCatalog.getString('Status'),
        field: 'activeDeviceInPrc',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Total'),
        field: 'totalVlt',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Inactive'),
        field: 'inactiveVlt',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Retailer No.'),
        field: 'retailerNumber',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Name'),
        field: 'retailerName',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Address'),
        field: 'retailerAddress',
        sortable: true,
      },
    ];
  }

  search() {
    this.gridModel.applyFilters();
  }

  onRetailerClick({ retailerId }) {
    this.selectedRetailerId = retailerId;
    this.showRetailerList = false;
  }
}

export default class SiteOperationalStatusWidgetComponent {
  constructor() {
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&',
    };
    this.controller = SiteOperationalStatusWidgetController;
    this.template = template;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/site-operational-status/site-operational-status-widget-component.js